import { render, staticRenderFns } from "./comment-creer-un-site-web-rentable.vue?vue&type=template&id=67252538&"
import script from "./comment-creer-un-site-web-rentable.vue?vue&type=script&lang=js&"
export * from "./comment-creer-un-site-web-rentable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports